import { useState } from "react";

import {
  Box,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  useDisclosure,
  Divider,
  IconButton,
  Input,
} from "@chakra-ui/react";

import { useTranslation } from "react-i18next";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { putCorrectAnswers } from "service/MyEvaluationServices";

export const AddAnswerModal = ({ questionId, correctAnswers, onSubmit }) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [answersList, setAnswersList] = useState(correctAnswers || [""]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    setIsLoading(true);
    putCorrectAnswers(questionId, answersList).then(() => {
      onClose();
      setIsLoading(false);
      onSubmit();
    });
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        w="500px"
        h="500px"
        isCentered
        borderRadius="xl"
      >
        <ModalOverlay />
        <ModalContent boxShadow="sm" borderRadius="xl">
          <ModalHeader w="100%">
            <Text p="4" textAlign="center">
              Adicione respostas de referencia para a questão
            </Text>
          </ModalHeader>
          <ModalBody>
            <Flex
              as={"form"}
              flexDirection="column"
              rowGap={2}
              pl="2"
              pr="2"
              width="100%"
              height="250px"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Divider mb={3} />
              <Flex
                w={"full"}
                h={"full"}
                flexDir={"column"}
                alignItems={"center"}
                rowGap={2}
                overflowY={"scroll"}
                justifyContent={"flex-start"}
                px={"4"}
                py={"2"}
              >
                {answersList.map((answer, index) => {
                  return (
                    <Flex
                      columnGap={2}
                      w="100%"
                      alignItems="center"
                      key={index}
                    >
                      <Input
                        value={answer}
                        onChange={(e) =>
                          setAnswersList(
                            answersList.map((item, i) => {
                              if (i === index) return e.currentTarget.value;
                              else return item;
                            })
                          )
                        }
                      />
                      <DeleteIcon
                        onClick={() =>
                          setAnswersList(
                            answersList.filter((item, i) => i !== index)
                          )
                        }
                        cursor={"pointer"}
                        color={"red"}
                      />
                    </Flex>
                  );
                })}
                <Button
                  p={3}
                  onClick={() => setAnswersList([...answersList, ""])}
                  rightIcon={<AddIcon />}
                  mt={3}
                >
                  Adicionar Resposta{" "}
                </Button>
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter mb="4" p="4" mx="8" justifyContent="space-between">
            <Button w="45%" size="md" type="submit" onClick={() => onClose()}>
              {t("CANCEL")}
            </Button>
            <Button
              w="45%"
              size="md"
              type="submit"
              colorScheme={"blue"}
              //   isDisabled={!selectedList.some((item) => item.checked)}
              onClick={() => handleSubmit()}
              isLoading={isLoading}
            >
              {t("CONCLUDE")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <IconButton
        icon={<EditIcon />}
        variant="ghost"
        colorScheme="blue"
        isRound={true}
        onClick={() => onOpen()}
        ml={1}
      />
    </>
  );
};
